{
    "asm": {
        "asm": {
            "mainLogoLabel": "SAP",
            "mainTitle": "Režim asistenčných služieb",
            "logout": "Odhlásiť sa",
            "hideUi": "Zavrieť ASM",
            "helpPortalUrl": "Pomocník",
            "customers": "Zákazníci",
            "asmCustomer360Button": "Zobrazenie Zákazník 360",
            "asmCustomer360ViewButton": "Zákazník 360°",
            "createCustomerSuccessfullyAlert": "Zákaznícky účet bol vytvorený a relácia zákazníka bola spustená.",
            "saveInactiveCartAlertInfo": "Identifikovaný košík nie je aktívny. Ak chcete s košíkom ďalej pracovať, musíte ho najskôr uložiť.",
            "activeCartAlertInfo": "Identifikovaný košík nie je aktívny.",
            "startCustomerEmulationAlertInfo": "Bola spustená emulácia zákazníka. Všetky vykonané činnosti budú mať vplyv na účet zákazníka.",
            "asmSignIn": "Prihlásiť sa",
            "asmSignInSso": "Prihlásiť cez SSO",
            "toggleUi": {
                "collapse": "Skryť ASM",
                "expand": "Zobraziť ASM"
            },
            "loginForm": {
                "submit": "Prihlásiť sa",
                "userId": {
                    "label": "ID alebo e-mail agenta"
                },
                "password": {
                    "label": "Heslo"
                }
            },
            "customerSearch": {
                "searchTerm": {
                    "label": "Meno / e-mailová adresa zákazníka"
                },
                "searchCustomer": {
                    "label": "Hľadať podľa mena alebo e-mailovej adresy"
                },
                "searchOrder": {
                    "label": "Hľadať podľa ID celej objednávky."
                },
                "submit": "Spustiť reláciu",
                "startEmulation": "Spustiť emuláciu",
                "noMatch": "Nenašiel sa žiadny zákazník",
                "noMatchResult": "Tento účet sa nedá nájsť.",
                "noCustomerMatchResult": "Nenašiel sa žiadny zodpovedajúci zákazník.",
                "noOrderMatchResult": "Vyhľadajte podľa celého ID objednávky.",
                "createCustomer": "Vytvoriť nového zákazníka",
                "customer": "Zákazník",
                "orderID": "ID objednávky"
            },
            "createCustomerForm": {
                "title": "Vytvoriť nového zákazníka",
                "createAccount": "Vytvoriť",
                "cancel": "Zrušiť",
                "firstName": {
                    "label": "Krstné meno",
                    "placeholder": "Krstné meno"
                },
                "lastName": {
                    "label": "Priezvisko",
                    "placeholder": "Priezvisko"
                },
                "emailAddress": {
                    "label": "E-mailová adresa",
                    "placeholder": "E-mailová adresa"
                },
                "createAccountAlert": "Relácia zákazníka začne po vytvorení účtu zákazníka.",
                "validationErrors": {
                    "firstName": "Zadajte platné krstné meno.",
                    "lastName": "Zadajte platné priezvisko.",
                    "emailAddress": "Zadajte platnú e-mailovú adresu."
                },
                "badRequestDuplicatedEmail": "Zadajte inú e-mailovú adresu, pretože {{ emailAddress }} už existuje."
            },
            "customerList": {
                "title": "Zoznam zákazníkov",
                "description": "Vyberte zákazníka z niektorého z poskytnutých zoznamov.",
                "createCustomer": "Vytvoriť nového zákazníka",
                "cancel": "Zrušiť",
                "tableHeader": {
                    "customer": "Zákazník",
                    "customerName": "Meno/názov zákazníka",
                    "name": "Meno/názov",
                    "email": "E-mail",
                    "emailId": "E-mail/ID",
                    "phone": "Telefón",
                    "account": "Účet",
                    "cart": "Košík",
                    "order": "Objednávka",
                    "view": "360 pohľad",
                    "activeCart": "Aktívny košík",
                    "viewActiveCart": "Zobraziť aktívny košík",
                    "orders": "Objednávky",
                    "viewOrders": "Zobraziť objednávky",
                    "customer360": "Zákazník 360°",
                    "viewCustomer360": "Zobraziť Zákazník 360°"
                },
                "tableSort": {
                    "sortBy": "Triediť podľa",
                    "byName": "Meno (vzostupne)",
                    "byNameAsc": "Meno (vzostupne)",
                    "byNameDesc": "Meno (zostupne)",
                    "byDateAsc": "Dátum (vzostupne)",
                    "byDateDesc": "Dátum (zostupne)",
                    "byOrderDateAsc": "Dátum objednávky (vzostupne)",
                    "byOrderDateDesc": "Dátum objednávky (zostupne)",
                    "byUnit": "Účet (vzostupne)",
                    "byUnitDesc": "Účet (zostupne)"
                },
                "page": {
                    "page": "Strana {{count}}",
                    "previous": "Predchádzajúca",
                    "next": "Ďalšia"
                },
                "noOfCustomers": "Počet zákazníkov: {{count}} ",
                "oneCustomer": "1 zákazník",
                "noCustomers": "V tomto zozname zákazníkov momentálne nie sú žiadni zákazníci.",
                "noLists": "Momentálne nie je k dispozícii žiadny zoznam zákazníkov. Kontaktujte správcu systému.",
                "listsError": "Zoznam zákazníkov sa nedá načítať. Skúste to znova neskôr.",
                "searchBox": "Hľadať",
                "enterSearchBox": "Zadajte meno alebo e-mail zákazníka"
            },
            "switchCustomer": {
                "dialog": {
                    "title": "Upozornenie",
                    "body": "Kliknutím na „Prepnúť zákazníka“ ukončíte emuláciu pre „{{ customerA }}“ a spustíte emuláciu pre „{{ customerB }}“. Všetky neuložené zmeny pre „{{ customerA }}“ budú stratené.",
                    "actions": {
                        "switch": "Prepnúť zákazníka"
                    }
                }
            },
            "saveCart": {
                "saveCartBtn": "Uložiť na neskôr",
                "dialog": {
                    "saveInfo": "Pred ďalšou činnosťou uložte košík.",
                    "disableInfo": "Košík sa nedá uložiť, pretože je prázdny.",
                    "title": "Uložiť košík",
                    "row": {
                        "id": "ID",
                        "qty": "Množstvo",
                        "qtyFull": "Množstvo",
                        "total": "Spolu"
                    },
                    "actions": {
                        "save": "Uložiť na neskôr"
                    }
                }
            },
            "bindCart": {
                "cartNumber": "Číslo košíka",
                "bindCartToCustomer": "Priradiť košík zákazníkovi",
                "success": "Košík bol úspešne priradený",
                "assignCartId": "Priradiť ID košíka zákazníkovi",
                "enterCartId": "Zadajte ID košíka",
                "resetCartId": "Resetovať",
                "dialog": {
                    "title": "Priradiť anonymný košík",
                    "body": "Chcete nahradiť aktuálny aktívny košík anonymným košíkom? Ak nahradíte aktuálny aktívny košík, uloží sa ako uložený košík.",
                    "actions": {
                        "replace": "Nahradiť košík"
                    }
                }
            },
            "csagentTokenExpired": "Časový limit relácie agenta zákazníckej podpory vypršal.",
            "endSession": "Ukončiť reláciu",
            "endEmulation": "Ukončiť emuláciu",
            "usersSalesNote": "Poznámka k zákazníkovi",
            "agentSessionTimer": {
                "label": "Časový limit relácie vypršal",
                "minutes": "min",
                "reset": "Resetovať"
            },
            "auth": {
                "agentLoggedInError": "Nemôžete sa prihlásiť ako používateľ, ak existuje aktívna relácia agenta zákazníckej podpory. Buď emulujte používateľa, alebo odhláste agenta zákazníckej podpory."
            },
            "error": {
                "noCustomerId": "Pre vybraného používateľa nebolo nájdené ID zákazníka. Reláciu nie je možné spustiť."
            }
        }
    }
}
